import React, {useEffect, useState} from 'react';
import post from '../utils/post.js';
import PopupSearch from './PopupSearch.js';
import usePopupAnimation from '../utils/usePopupAnimation.js';

export default function UserReservationsPopup({showReservations, closeReservations, user, listRows}) {
	const popupAnimationMs = 300;
	const [data, setData] = useState([]);
	const [search, setSearch] = useState('');
	const [loadedCnt, setLoadedCnt] = useState(0);
	const [loading, setLoading] = useState(false);
	const {shouldRender, isClosing} = usePopupAnimation(showReservations, popupAnimationMs);

	useEffect(() => {
		if (showReservations && user?.ID) {
			setSearch('');
			getData('', 0);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showReservations, user?.ID]);

	const getData = (searchValue, requestedOffset) => {
		if (!user?.ID) {
			return;
		}

		setLoading(true);

		post('getListUserReservations', {USRID: user.ID, search: searchValue, offset: requestedOffset})
			.then((res) => {
				const rows = res.data?.data || [];

				if (requestedOffset === 0) {
					setData(rows);
				} else {
					setData((prevRows) => [...prevRows, ...rows]);
				}

				setLoadedCnt(rows.length);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const onChangeSearch = (value) => {
		setSearch(value);
		getData(value, 0);
	};

	const loadNext = () => {
		getData(search, data.length);
	};

	const list = data.map((reservation, index) => (
		<div className={`user-reservations-popup__item${parseInt(reservation.IS_FUTURE, 10) === 1 ? ' is-future' : ''}`} key={reservation.ID || index}>
			<div className="user-reservations-popup__name">
				<span>{String(reservation.RESERVATIONDT || '').replace(' ', ' - ')}</span>
				<span className="user-reservations-popup__meta">
					{reservation.RESERVATIONLNG_H}h{reservation.ADD_PERSON > 0 ? ` +${reservation.ADD_PERSON}x` : ''}
				</span>
			</div>
			<div className="user-reservations-popup__payment-icons">
				<img className={`icon1 ${parseInt(reservation.PAYED, 10) === 1 ? 'ok1' : 'ok0'} user-reservations-popup__payment-icon`} alt={parseInt(reservation.PAYED, 10) === 1 ? 'Vstup zaplacen' : 'Vstup nezaplacen'} title={parseInt(reservation.PAYED, 10) === 1 ? 'Vstup zaplacen' : 'Vstup nezaplacen'} />
				{reservation.ADD_PERSON > 0 ? (
					<img className={`icon1 ${parseInt(reservation.ADD_PERSON_PAYED, 10) === 1 ? 'ok1' : 'ok0'} user-reservations-popup__payment-icon`} alt={parseInt(reservation.ADD_PERSON_PAYED, 10) === 1 ? 'Doprovod zaplacen' : 'Doprovod nezaplacen'} title={parseInt(reservation.ADD_PERSON_PAYED, 10) === 1 ? 'Doprovod zaplacen' : 'Doprovod nezaplacen'} />
				) : null}
			</div>
		</div>
	));

	return (
		<>
			{shouldRender ? (
				<div className={`popup user-reservations-popup${isClosing ? ' popup--closing' : ''}`}>
					<div className={`popup_content user-reservations-popup__content${isClosing ? ' popup_content--closing' : ''}`}>
						<div className="popup_content_in_head">
							<div className="popup_content_in_head_in">Rezervace</div>
							<img
								alt=""
								className="popup_content_in_head_in-close"
								onClick={() => {
									closeReservations();
								}}
							/>
						</div>
						<div className="popup_content_in_body popup_content_in_body--hidden-scrollbar user-reservations-popup__body">
							<div className="popup_content_in_body_in user-reservations-popup__body-in">
								<div className="user-reservations-popup__search-wrap">
									<PopupSearch searchValue={search} onChangeSearch={onChangeSearch} placeholder="Vyhledat v rezervacích" className="user-reservations-popup__search" />
								</div>
								<div className="popup_content_in_body--hidden-scrollbar user-reservations-popup__list-wrap">
									<div className="user-reservations-popup__list">
										{list.length > 0 ? list : <div className="user-reservations-popup__empty">{loading ? 'Načítám rezervace...' : 'Žádné rezervace nebyly nalezeny.'}</div>}
										{parseInt(loadedCnt, 10) === (parseInt(listRows, 10) || 25) ? (
											<div className="user-reservations-popup__load-more">
												<button type="button" className="button green" onClick={loadNext} disabled={loading}>
													Načíst další
												</button>
											</div>
										) : null}
									</div>
								</div>
							</div>
						</div>
						<div className="popup_content_in_foot">
							<div className="popup_content_in_foot_in user-reservations-popup__foot">
								<button
									type="button"
									className="button"
									onClick={() => {
										closeReservations();
									}}
								>
									Zpět
								</button>
							</div>
						</div>
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
}
